import React from "react";
import styles from "./TransactionCard.module.scss";

interface TransactionCardProps {
	icon: React.ReactNode;
	leftTitle: string;
	leftSubTitle: string;
	rightTitle: string;
	status: string;
	onClick?: () => void;
}

export const TransactionCard: React.FC<TransactionCardProps> = ({ icon, leftTitle, leftSubTitle, rightTitle, status, onClick }) => {
	const handleKeyDown = (event: React.KeyboardEvent) => {
		if (!onClick) return;
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			onClick();
		}
	};

	return (
		<div
			className={`${styles.card} ${onClick ? styles.clickable : ""}`}
			onClick={onClick}
			onKeyDown={handleKeyDown}
			role={onClick ? "button" : undefined}
			tabIndex={onClick ? 0 : undefined}
		>
			<div className={styles.iconContainer}>{icon}</div>
			<div className={styles.left}>
				<span className={styles.leftTitle}>{leftTitle}</span>
				<span className={styles.leftSubTitle}>{leftSubTitle}</span>
			</div>
			<div className={styles.right}>
				<span className={styles.rightTitle}>{rightTitle}</span>
				<span className={styles.status}>{status}</span>
			</div>
		</div>
	);
};
